var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"find-tab-wrap",class:("find-tab-wrap-" + _vm.gender)},[_c('resourceBanner',{attrs:{"bannerList":_vm.resourceBannerList},on:{"switchCanSwiper":function (val) {
                this$1.$emit('switchCanSwiper', val);
            }}}),_vm._l((_vm.displayModules),function(moduleItem){return _c(_vm.modulesMap[moduleItem.cardType],{key:moduleItem.moduleId,tag:"component",attrs:{"moduleInfo":moduleItem}})}),(_vm.displayModules.length)?_c('Registration'):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }